import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=03762e5c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03762e5c')) {
      api.createRecord('03762e5c', component.options)
    } else {
      api.reload('03762e5c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=03762e5c&", function () {
      api.rerender('03762e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Fsngc5EpV7S/JS/imageCarousel.vue"
export default component.exports